import React from "react";
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import Dropzone from "../dropzone";
import Select from "react-select";

import { isGuid } from "../../utils/string";

class DropZoneModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            references: null,
            hidden: false,
            uuid: this.props.uuid || "",
            category: this.props.category || "General"
        }
    }

    onHideModal = (e) => {
        this.onCancel(e)
    }

    postChange = () => {
        
    }

    componentDidUpdate = (old) => {
        if ((old?.uuid !== this.props.uuid) || (old?.category !== this.props.category)) {
            this.setState({
                uuid: this.props.uuid,
                category: this.props.category
            })
        }
    }

    onHiddenChange = (e) => {
        const checked = e.target.checked;
        this.setState({
            category: checked ? "hidden" : (this.props.category || "General")
        });
    };

    onReferenceChange = (opt) => {
        if (!opt) {
            this.setState({ uuid: "", category: this.props.category || "General" });
            return;
        }

        if (this.state.uuid !== opt.value) {
            this.setState(
                {
                    uuid: opt.value,
                    category: opt.category ?? this.state.category
                },
                this.postChange
            );
        }
    };


    onFileUpload = (file) => {
        const uploadedFile = file?.item || file?.file || file;
        this.setState({
            file: { ...uploadedFile }
        })
    }

    get fileUploaded() {
        return (this.state.file && isGuid(this.state.file.uuid));
    }

    onCancel = async (e) => {
        if (this.fileUploaded) {
            if (this.props?.removeFile) await this.props.removeFile(this.props.marriageUuid, this.state.file.uuid);
        }
        this.props?.onCancel(e, this.state);
    }

    onOk = (e) => {
        this.props.onOk(e, this.state);
    }

    render() {
        if (!this.props.show) {
            return <></>
        }
        return (
            <Modal size="lg" backdrop="static" keyboard show={this.props.show} onHide={this.onHideModal}>
                <Modal.Header closeButton>
                    <Modal.Title id="staticBackdropLabel">{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.children ? (
                        <Row className="g-3 pb-3 mt-1">
                            <Col xs="12">{this.props.children}</Col>
                        </Row>
                    ) : null}
                    
                    {(this.props.references) ? (
                        <Row className="g-3 pb-3 mt-1">
                            <Col xs="12" md="10">
                                <Select
                                    id="references"
                                    value={this.props.references.find(option => option.value === this.state.uuid)}
                                    name="references"
                                    onChange={this.onReferenceChange}
                                    classNamePrefix="react-select"
                                    placeholder="Refers To"
                                    options={this.props.references}
                                >
                                </Select>
                            </Col>
                            <Col md="2" style={{ marginTop: "22px" }}>
                                <Form.Check type="checkbox" label="Internal" value="1" id="internal" inline name="hidden" checked={this.state?.category === "hidden"} onChange={this.onHiddenChange} />
                            </Col>
                        </Row>
                    ) : ``}
                    {(isGuid(this.state.uuid) && (this.state.category)) ? (
                        <Dropzone label="Upload file" accept={this.props.accept} multiple={false} url={ this.props.url } uuid={this.state.uuid} category={this.state.category} onFileUpload={ this.onFileUpload } />
                    ) : (this.props.onGetUrl) ? (
                        <Dropzone label="Upload file" accept={this.props.accept} multiple={false} onGetUrl={this.props.onGetUrl} onFileUpload={ this.onFileUpload } />
                    ) : ``}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.onCancel}>Cancel</Button>
                    <Button variant="primary" disabled={!this.fileUploaded} onClick={this.onOk}>OK</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default DropZoneModal;
